/**
 * ModernSidebar - Sidebar Component for Modern Layout
 * 
 * Uses the shared UI component library Sidebar.
 */

import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Sidebar } from '@crc-evans/ui-components';
import {
  LayoutDashboard,
  FolderOpen,
  Briefcase,
} from 'lucide-react';
import './ModernSidebar.css';

const ModernSidebar = (props) => {
  const history = useHistory();
  const location = useLocation();
  // Determine initial active state based on current path
  const [activeId, setActiveId] = useState(() => {
    const path = window.location.pathname;
    if (path === '/projects' || path.startsWith('/projects/') || path === '/dpr' || path.startsWith('/dpr')) {
      return 'projects';
    }
    return 'dashboard';
  });

  // Get user info from localStorage
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userGroup = JSON.parse(localStorage.getItem('UserGroup') || '[]');

  // Map user data for Sidebar component
  const defaultUser = {
    name: user['custom:first_name'] && user['custom:last_name']
      ? `${user['custom:first_name']} ${user['custom:last_name']}`
      : user['custom:first_name'] || 'User',
    role: (userGroup?.includes('super-admin') || userGroup?.includes('admin')) ? 'Administrator' : 'User',
    initials: (
      (user['custom:first_name']?.charAt(0) || '') +
      (user['custom:last_name']?.charAt(0) || '')
    ).toUpperCase() || 'U'
  };

  // Update active state based on current route (highlight Projects when on DPR or projects)
  useEffect(() => {
    const path = location.pathname;
    if (path === '/projects' || path.startsWith('/projects/') || path === '/dpr' || path.startsWith('/dpr')) {
      setActiveId('projects');
    } else {
      setActiveId('dashboard');
    }
  }, [location.pathname]);

  const handleItemClick = (itemId) => {
    // Only Projects has a link for now; Dashboard and Admin have no links
    if (itemId === 'projects') {
      setActiveId('projects'); // Explicitly set activeId for immediate UI feedback
      history.push('/projects');
    }
  };

  const items = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: LayoutDashboard,
    },
    {
      id: 'projects',
      label: 'Projects',
      icon: FolderOpen,
    }
  ];

  if (userGroup?.includes('admin') || userGroup?.includes('super-admin')) {
    items.push({
      id: 'admin',
      label: 'Admin',
      icon: Briefcase,
    });
  }

  return (
    <Sidebar
      items={items}
      activeItemId={activeId}
      onItemClick={handleItemClick}
      user={defaultUser}
      className="modern-sidebar-override"
    />
  );
};

const mapStateToProps = ({ auth }) => ({
  userAccess: auth?.userAccess || [],
});

export default connect(mapStateToProps)(ModernSidebar);
